// import React from "react";

// const Marquee = () => {
//   // Marquee items data array

//   const marqueeItems = [
//     { id: 1, text: "Cash on Delivery: Pay When It Arrives!" },
//     { id: 2, text: "Free Shipping on orders above ₹499!" },
//     { id: 3, text: "Use code HUEHOP10 for 10% off your first order!" },
//     { id: 4, text: "Joy-First Kids Lifestyle Brand - Hop Into Your Hue!" },
//     { id: 5, text: "Easy 7-Day Returns!" },
//     { id: 6, text: "Use code HUEHOP10 for 10% off your first order!" },
//   ];
//   // SVG Icon Component
//   const StarIcon = () => (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="29"
//       height="50"
//       viewBox="0 0 29 50"
//       fill="none"
//     >
//       <path
//         d="M28.1409 17.5H16.4759L27.2894 0.833301H13.666L0.894062 25.8333H10.9413L0.894062 49.1667L28.1409 17.5Z"
//         fill="#FFDD09"
//       />
//       <path
//         d="M17.0718 0.833301H13.666L0.894062 25.8333H4.29989L17.0718 0.833301Z"
//         fill="white"
//       />
//       <path
//         d="M23.8836 17.5L3.44846 41.25L0.0426318 49.1667L27.2894 17.5H23.8836Z"
//         fill="#FD9808"
//       />
//       <path
//         d="M0.894062 50C0.723736 50 0.55351 50 0.468297 49.9167C0.127745 49.6667 -0.0425815 49.25 0.127745 48.9167L9.66411 26.6667H0.894062C0.638623 26.6667 0.298071 26.5 0.127745 26.25C-0.0425815 26 -0.0425815 25.6667 0.127745 25.4167L12.8997 0.416699C13.07 0.166699 13.3255 0 13.666 0H27.2894C27.63 0 27.8854 0.166699 28.0557 0.416699C28.2261 0.666699 28.2261 1 28.0557 1.25L18.0936 16.6667H28.1409C28.4814 16.6667 28.7368 16.8334 28.9072 17.1667C29.0775 17.5 28.9923 17.8334 28.8221 18.0834L1.57517 49.75C1.40494 49.9167 1.1495 50 0.894062 50ZM2.25637 25H10.9413C11.1967 25 11.4522 25.1667 11.6225 25.3333C11.7928 25.5833 11.7928 25.8333 11.7076 26.0833L3.87412 44.4166L26.3528 18.3333H16.4758C16.1352 18.3333 15.8798 18.1666 15.7094 17.9166C15.5391 17.6666 15.5391 17.3333 15.7094 17.0833L25.7568 1.6667H14.1769L2.25637 25Z"
//         fill="black"
//       />
//     </svg>
//   );

//   return (
//     <div
//       className="tf-marquee marquee-xl"
//       style={{
//         borderTop: "1.5px solid #f4f4f4",
//         borderBottom: "1.5px solid #f4f4f4",
//       }}
//     >
//       <div className="wrap-marquee">
//         {marqueeItems.map((item) => (
//           <div className="marquee-item" key={item.id}>
//             <div className="icon">
//               <StarIcon />
//             </div>
//             <p className="text">{item.text}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Marquee;

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const marqueeItems = [
  { id: 1, text: "Free Shipping on orders above ₹499!" },
  { id: 2, text: "Cash on Delivery: Pay When It Arrives!" },
  { id: 3, text: "Easy 7-Day Returns!" },
  { id: 4, text: "Cash on Delivery: Pay When It Arrives!" },
  { id: 5, text: "Use code HUEHOP10 for 10% off on 1st order!" },
];

const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="50"
    viewBox="0 0 29 50"
    fill="none"
  >
    <path
      d="M28.1409 17.5H16.4759L27.2894 0.833301H13.666L0.894062 25.8333H10.9413L0.894062 49.1667L28.1409 17.5Z"
      fill="#FFDD09"
    />
    <path
      d="M17.0718 0.833301H13.666L0.894062 25.8333H4.29989L17.0718 0.833301Z"
      fill="white"
    />
    <path
      d="M23.8836 17.5L3.44846 41.25L0.0426318 49.1667L27.2894 17.5H23.8836Z"
      fill="#FD9808"
    />
    <path
      d="M0.894062 50C0.723736 50 0.55351 50 0.468297 49.9167C0.127745 49.6667 -0.0425815 49.25 0.127745 48.9167L9.66411 26.6667H0.894062C0.638623 26.6667 0.298071 26.5 0.127745 26.25C-0.0425815 26 -0.0425815 25.6667 0.127745 25.4167L12.8997 0.416699C13.07 0.166699 13.3255 0 13.666 0H27.2894C27.63 0 27.8854 0.166699 28.0557 0.416699C28.2261 0.666699 28.2261 1 28.0557 1.25L18.0936 16.6667H28.1409C28.4814 16.6667 28.7368 16.8334 28.9072 17.1667C29.0775 17.5 28.9923 17.8334 28.8221 18.0834L1.57517 49.75C1.40494 49.9167 1.1495 50 0.894062 50ZM2.25637 25H10.9413C11.1967 25 11.4522 25.1667 11.6225 25.3333C11.7928 25.5833 11.7928 25.8333 11.7076 26.0833L3.87412 44.4166L26.3528 18.3333H16.4758C16.1352 18.3333 15.8798 18.1666 15.7094 17.9166C15.5391 17.6666 15.5391 17.3333 15.7094 17.0833L25.7568 1.6667H14.1769L2.25637 25Z"
      fill="black"
    />
  </svg>
);

const Marquee = () => {
  return (
    <div
      style={{
        borderBottom: "1.5px solid #f4f4f4",
        overflow: "hidden",
      }}
    >
      <Swiper
        modules={[Autoplay]}
        slidesPerView="auto"
        loop={true}
        speed={5000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        allowTouchMove={false}
        style={{ cursor: "default" }}
      >
        {/* Loop ke liye items double karo */}
        {[...marqueeItems, ...marqueeItems].map((item, index) => (
          <SwiperSlide key={`${item.id}-${index}`} style={{ width: "auto" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "32px 16px",
                whiteSpace: "nowrap",
              }}
            >
              <StarIcon />
              <p
                style={{
                  margin: 0,
                  fontSize: 18,
                  fontWeight: 500,
                  color: "#2c3a34",
                }}
              >
                {item.text}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Marquee;
